import type * as Sentry from "@sentry/nextjs";

/**
 * What the Sentry SDK may collect automatically, shared by the client,
 * server and edge configs. SDK 11 replaced `sendDefaultPii: false` with
 * this option, and its defaults collect almost everything, so every field
 * is set explicitly. Events can carry SMS content, child YouTube data,
 * invite tokens in query strings and OAuth tokens in local variables.
 */
export const SENTRY_DATA_COLLECTION: NonNullable<Sentry.BrowserOptions["dataCollection"]> = {
  userInfo: false,
  cookies: false,
  httpHeaders: false,
  httpBodies: [],
  urlQueryParams: false,
  graphQL: { document: false, variables: false },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  stackFrameVariables: false,
};
